import * as React from 'react';
import { CurrentLocationRouteDispatchContext } from '../contexts';

/**
 * Use the current client dispatch function from the combined contexts
 *
 * @returns The current client dispatch update
 */
export function useCurrentLocationDispatch(): (newLocationId: string) => void {
    const dispatchToRouteContext = React.useContext(CurrentLocationRouteDispatchContext);
    return newValue => {
        dispatchToRouteContext?.(newValue);
    };
}
